<template>
	<div class="match-filters__container" :class="customClassFilter">
		<div class="match-filters">
			<sort-and-filter
				:markets="markets"
				:currentMarket="currentMarket"
				@change-market="(market) => $emit('change-market', market)"
				:sortOptions="sortOptions"
				:sortBy="sortBy"
				@change-sort-option="(option) => $emit('change-sort-option', option)"
				:periods="periods"
				:currentPeriod="currentPeriod"
				@change-current-period="
					(period) => $emit('change-current-period', period)
				"
				@applied-all-game-filters="appliedAllGameFilters"
				@apply="$emit('apply')"
				@reset="$emit('reset')"
			/>
			<div class="match-filters__right">
				<period
					:periods="periods"
					:currentPeriod="currentPeriod"
					@change-current-period="
						(period) => $emit('change-current-period', period)
					"
					@applied-game-filter="appliedGameFilter"
					@apply="$emit('apply')"
					@reset="$emit('reset')"
					style="margin-right: 2px"
					v-if="periods.length > 0"
				/>
				<sort-by
					:sortOptions="sortOptions"
					:sortBy="sortBy"
					@change-sort-option="(option) => $emit('change-sort-option', option)"
					@applied-game-filter="appliedGameFilter"
					@apply="$emit('apply')"
					@reset="$emit('reset')"
					style="margin-right: 2px"
					v-if="sortOptions.length > 0"
				/>
				<market
					:markets="markets"
					:currentMarket="currentMarket"
					@change-market="(market) => $emit('change-market', market)"
					@applied-game-filter="appliedGameFilter"
					@apply="$emit('apply')"
					@reset="$emit('reset')"
					v-if="markets.length > 0"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import SortAndFilter from "./SortAndFilter.vue";
import SortBy from "./SortBy.vue";
import Market from "./Market.vue";
import Period from "./Period.vue";
export default {
	components: { SortAndFilter, SortBy, Market, Period },
	props: {
		markets: {
			type: Array,
			required: true,
			default: () => [],
		},
		currentMarket: {
			type: Object,
			required: true,
			default: () => ({
				name: "1x2",
				sub_type_id: "1",
			}),
		},
		sortOptions: {
			type: Array,
			required: true,
			default: () => [],
		},
		sortBy: {
			type: Object,
			required: true,
			default: () => ({
				name: this.$t("prebets.top-leagues"),
				sort_id: 1,
			}),
		},
		periods: {
			type: Array,
			required: false,
			default: () => [],
		},
		currentPeriod: {
			type: Object,
			required: false,
			default: () => ({
				id: -1,
				name: "Today",
			}),
		},
		customClassFilter: {
			type: String,
			required: false,
			default: "",
		},
	},
	data() {
		return {
			gameFilter: [],
		};
	},
	methods: {
		appliedGameFilter(values) {
			let vm = this;
			vm.gameFilter.push(values);
			const delimitGameFilterItem = vm.gameFilter.join(" | ");
			this.analyticsTrack("general", "filterApplied", {
				filter_selection: delimitGameFilterItem,
			});
		},
		appliedAllGameFilters(values) {
			let vm = this;
			const selectedFilter = values.map((item) => item.name);
			const delimitGameFilterItem = selectedFilter.join(" | ");

			this.analyticsTrack("general", "filterApplied", {
				filter_selection: delimitGameFilterItem,
			});
		},
	},
};
</script>

<style lang="scss">
.match-filters {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding: 0 8px 10px 8px;
	background: var(--white);
	overflow-x: auto;
	@media (min-width: 1023px) {
		overflow-x: initial;
	}
	&__right {
		display: flex;
		flex-direction: row;
		justify-content: space-evenly;
	}
}
.match-filter {
	&__buttons {
		padding: 10px;
	}
	&__button {
		font-size: var(--font-small);
		border: none;
		background: var(--light-gray);
		color: var(--black);
		border-radius: 25px;
		padding: 5px 10px;
		white-space: nowrap;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-right: 2px;
		&.main {
			margin-right: 20px;
		}
		&__label {
			flex: 5;
		}
		&__caret {
			flex-basis: 10px;
			fill: var(--black);
			margin-left: 5px;
			width: 12px;
			height: 8px;
			margin-bottom: -2px;
		}
		&__icon {
			flex-basis: 10px;
			fill: var(--black);
			margin-right: 5px;
			width: 13px;
		}
	}
	&__container {
		padding: 20px 30px;
		max-height: 60vh;
		overflow-y: auto;
	}
	&__group {
		margin-bottom: 20px;
		&__title {
			margin: 0;
			margin-bottom: 5px;
			color: var(--black);
			font-size: var(--font-large);
		}
		&__actions {
			display: flex;
			flex-direction: column;
		}
		&__action {
			background: none;
			text-align: left;
			border: none;
			padding: 10px 0;
			color: var(--dark-blue);
			font-size: var(--font-medium);
			position: relative;
			&.active {
				background-repeat: no-repeat;
				background-position: 98% center;
				background-image: url("data:image/svg+xml,%0A%3Csvg width='14' height='11' viewBox='0 0 14 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.75781 10.7539C4.86719 10.918 5.03125 10.9727 5.25 10.9727C5.44141 10.9727 5.60547 10.918 5.74219 10.7539L13.8086 2.71484C13.918 2.60547 14 2.44141 14 2.22266C14 2.03125 13.918 1.86719 13.8086 1.73047L12.7969 0.746094C12.6602 0.609375 12.4961 0.527344 12.3047 0.527344C12.1133 0.527344 11.9492 0.609375 11.8125 0.746094L5.25 7.30859L2.1875 4.24609C2.02344 4.10938 1.85938 4.02734 1.66797 4.02734C1.47656 4.02734 1.3125 4.10938 1.20312 4.24609L0.191406 5.23047C0.0546875 5.36719 0 5.53125 0 5.72266C0 5.94141 0.0546875 6.10547 0.191406 6.21484L4.75781 10.7539Z' fill='%2360981A'/%3E%3C/svg%3E%0A");
			}
		}
	}
	&__apply {
		background: var(--green);
		font-style: normal;
		font-weight: var(--font-weight-medium);
		font-size: var(--font-medium);
		line-height: 20px;
		border: none;
		padding: 8px 0;
		text-align: center;
		color: var(--always-white);
		display: block;
		width: 100%;
		margin-bottom: 10px;
	}
	&__reset {
		background: none;
		font-style: normal;
		font-weight: var(--font-weight-medium);
		font-size: var(--font-medium);
		line-height: 20px;
		border: none;
		padding: 8px 0;
		text-align: center;
		color: var(--black);
		display: block;
		width: 100%;
	}
}
</style>
